// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-report-form-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff; 
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.summary-date-field {
  display: flex;
  flex-direction: column;
  width: 25%
}

.summary-date-field label {
  font-weight: bold;
  margin-bottom: 8px;
  text-align: left;
}

.summary-date-field input {
  padding: 10px 5px;
  font-size: 16px;
  border: 1px solid #f2f2f2;
}

.summary-form-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 15px 0 0;
}

.summary-form-actions .btn {
  padding: 8px 16px;
  font-size: 16px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.summary-form-actions .submit-btn {
  background-color: #44a67e;
  border-color: #44a67e;
}

.summary-form-actions .submit-btn:hover {
  background-color: #44a67e;
  border-color: #44a67e;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

.summary-form-actions .download-btn {
  background: #373435;
  color: #ffcc29;
}

.summary-form-actions .download-btn:hover {
  background: #373435;
  color: #ffcc29;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

/* Responsive Styles */
@media (max-width: 700px) {
  .summary-report-form-filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .summary-date-field input {
    max-width: 100%;
  }

  .summary-form-actions {
    flex-direction: column;
    width: 100%;
  }

  .summary-form-actions .btn {
    width: 100%;
    text-align: center;
  }
}


/* Ensure Table is Scrollable on Small Screens */
.summary-table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.summary-report-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.summary-report-table th,
.summary-report-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.summary-report-table th {
  background-color: #f4f4f4;
  color: #373435;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
}

.summary-report-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.summary-report-table tbody tr:hover {
  background-color:  rgba(255, 204, 41, 0.2);
}

.summary-report-table td {
  color: #373435;
}

.summary-report-table tbody tr:last-child td {
  border-bottom: 2px solid #ffcc29;
}

/* Expand Button */
.summary-report-expand-btn {
  background: #373435;
  color: #ffcc29;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.summary-report-expand-btn:hover {
  background: #ffcc29;
  color: #373435;
}

/* Expanded Row */
.summary-report-expanded-row {
  background-color: #eef7ff;
}

.summary-report-expanded-content {
  padding: 10px;
}

@media screen and (max-width: 1000px) {
  .under-1000px {
    display: none;
  }
}

@media screen and (min-width: 1001px) {
  .toggle-button-expansion {
    display: none;
  }
}

/* Make Table Rows Stack on Small Screens */
@media screen and (max-width: 768px) {
  .summary-report-form-filter {
      flex-direction: column;
      align-items: flex-start;
  }

  .summary-date-field {
      width: 100%;
      align-items: center;
  }

  .summary-form-actions {
      flex-direction: column;
      width: 100%;
  }
}

.wrap-summary-report {
  margin: 0 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/SummaryReport/SummaryReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qFAAqF;AACvF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;;AAGA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE;MACI,sBAAsB;MACtB,uBAAuB;EAC3B;;EAEA;MACI,WAAW;MACX,mBAAmB;EACvB;;EAEA;MACI,sBAAsB;MACtB,WAAW;EACf;AACF;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".summary-report-form-filter {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff; \r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.summary-date-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 25%\r\n}\r\n\r\n.summary-date-field label {\r\n  font-weight: bold;\r\n  margin-bottom: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.summary-date-field input {\r\n  padding: 10px 5px;\r\n  font-size: 16px;\r\n  border: 1px solid #f2f2f2;\r\n}\r\n\r\n.summary-form-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 15px 0 0;\r\n}\r\n\r\n.summary-form-actions .btn {\r\n  padding: 8px 16px;\r\n  font-size: 16px;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.summary-form-actions .submit-btn {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n}\r\n\r\n.summary-form-actions .submit-btn:hover {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n.summary-form-actions .download-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n}\r\n\r\n.summary-form-actions .download-btn:hover {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 700px) {\r\n  .summary-report-form-filter {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n\r\n  .summary-date-field input {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .summary-form-actions {\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .summary-form-actions .btn {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n\r\n/* Ensure Table is Scrollable on Small Screens */\r\n.summary-table-container {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  margin-top: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n}\r\n\r\n.summary-report-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  text-align: left;\r\n}\r\n\r\n.summary-report-table th,\r\n.summary-report-table td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.summary-report-table th {\r\n  background-color: #f4f4f4;\r\n  color: #373435;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n.summary-report-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.summary-report-table tbody tr:hover {\r\n  background-color:  rgba(255, 204, 41, 0.2);\r\n}\r\n\r\n.summary-report-table td {\r\n  color: #373435;\r\n}\r\n\r\n.summary-report-table tbody tr:last-child td {\r\n  border-bottom: 2px solid #ffcc29;\r\n}\r\n\r\n/* Expand Button */\r\n.summary-report-expand-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.summary-report-expand-btn:hover {\r\n  background: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n/* Expanded Row */\r\n.summary-report-expanded-row {\r\n  background-color: #eef7ff;\r\n}\r\n\r\n.summary-report-expanded-content {\r\n  padding: 10px;\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .under-1000px {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1001px) {\r\n  .toggle-button-expansion {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Make Table Rows Stack on Small Screens */\r\n@media screen and (max-width: 768px) {\r\n  .summary-report-form-filter {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n  }\r\n\r\n  .summary-date-field {\r\n      width: 100%;\r\n      align-items: center;\r\n  }\r\n\r\n  .summary-form-actions {\r\n      flex-direction: column;\r\n      width: 100%;\r\n  }\r\n}\r\n\r\n.wrap-summary-report {\r\n  margin: 0 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
